export type VariableEditorScope = "Project" | "PlatformHub" | "Unscoped";

export const isProjectScoped = (scope: VariableEditorScope) => {
    return scope === "Project";
};

export const isPlatformHubScoped = (scope: VariableEditorScope) => {
    return scope === "PlatformHub";
};
